import { Navigate, Outlet, useParams } from "react-router-dom";
import {
  getLandingCompanyNameFromPath,
  persistLandingCompanyName,
} from "../../utils/landingCompany";

export default function CompanyAuthGate() {
  const { landingCompanyName } = useParams();
  const decoded = decodeURIComponent(landingCompanyName || "");
  const companyName = getLandingCompanyNameFromPath(`/${decoded}`);

  if (!companyName) {
    return <Navigate to={`/${decoded}`} replace />;
  }

  persistLandingCompanyName(companyName);
  return <Outlet />;
}
